import { graphqlFetch } from '@pylot-data/graphqlFetch'
import { recentpost } from '@pylot-data/hooks/blog/graphql/blogQuery'
import { AuthorTree, Maybe } from '@pylot-data/pylotschema'

export interface RecentBlogPost {
    author: Maybe<AuthorTree>
    featured_image: string
    featured_list_image: string
    identifier: string
    post_id: number
    post_url: string
    title: string
    creation_time: string
    publish_time: string
    modified_time: string
}

export type BlogrecentpostResult = {
    blogPosts: {
        items: RecentBlogPost[]
    }
}

export type blogrecentpostVariables = {
    pageSize?: number
}

export type GetBlogrecentpostResult = BlogrecentpostResult

async function getRecentpost({
    pageSize,
    locale
}: {
    pageSize: number
    locale: string
}): Promise<GetBlogrecentpostResult | undefined | null> {
    const blogDataPromise = graphqlFetch<
        blogrecentpostVariables,
        GetBlogrecentpostResult
    >({
        query: recentpost,
        variables: {
            pageSize: pageSize
        },
        locale
    })
    const [blogData] = await Promise.all([blogDataPromise])
    return {
        blogPosts: blogData.data.blogPosts
    }
}

export default getRecentpost
